import Vue from 'vue';
import PortalVue from 'portal-vue';
import collection from '@/collection';
import { Props } from '@/types';

Vue.use(PortalVue);

Vue.config.productionTip = false;

document.addEventListener('DOMContentLoaded', async () => {
  const elementsShouldBeMounted = document.querySelectorAll('div[data-props]');

  for (const el of elementsShouldBeMounted) {
    const props = JSON.parse(el.getAttribute('data-props') || '{}') as Props;
    const getVueInstance = collection[el.id];
    if (getVueInstance) {
      (await getVueInstance(props)).$mount(el);
    }
  }
});
